import scrollLock from 'scroll-lock';
import gsap from 'gsap';

export default class Menu {
	constructor() {
		this.hamburger = document.querySelector('[data-hamburger]');
		this.menu = document.querySelector('[data-menu]');
		this.header = document.querySelector('[data-header]');

		this.menuOpen = false;

		this.hamburger.addEventListener('click', (e) => {
			this.toggleMenu();
		});

		this.submenuToggles = document.querySelectorAll('[data-submenu-toggle]');

		this.submenuToggles.forEach((toggle) => {
			toggle.addEventListener('click', () => {
				this.toggleSubmenu(toggle);
			});
		});

		const menuItems = document.querySelectorAll('.c-menu__item--has-children');

		menuItems.forEach((item) => {
			item.addEventListener('focusout', (e) => {
				if (!item.contains(e.relatedTarget)) {
					const toggle = item.querySelector('[data-submenu-toggle]');
					const submenu = item.querySelector('.c-submenu');

					if (toggle.getAttribute('aria-expanded') === 'true') {
						this.closeSubmenu(toggle, submenu);
					}
				}
			});
		});

		const focusableElementsString =
			'a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])';
		const focusableElements = this.menu.querySelectorAll(focusableElementsString);

		if (focusableElements.length > 0) {
			const firstFocusableEl = focusableElements[0];
			const lastFocusableEl = focusableElements[focusableElements.length - 1];

			window.addEventListener('keydown', (e) => {
				if (window.innerWidth < 1200 && this.menuOpen) {
					if (e.key === 'Escape') {
						this.closeMenu();
					}

					if (e.key === 'Tab') {
						if (e.shiftKey) {
							// Shift + Tab
							if (document.activeElement === firstFocusableEl) {
								lastFocusableEl.focus();
								e.preventDefault();
							}
						} else {
							// Tab
							if (document.activeElement === lastFocusableEl) {
								firstFocusableEl.focus();
								e.preventDefault();
							}
						}
					}
				}
			});
		}
	}

	toggleMenu() {
		this.menuOpen ? this.closeMenu() : this.openMenu();
	}

	openMenu() {
		this.menuOpen = true;

		scrollLock.disablePageScroll();

		this.menu.classList.add('is-active');
		this.header.classList.add('has-open-menu');

		this.hamburger.classList.add('is-active');
		this.hamburger.setAttribute('aria-expanded', true);
		this.hamburger.setAttribute('aria-label', 'Sluit het menu');
	}

	closeMenu() {
		if (!this.menuOpen) {
			return new Promise((resolve) => {
				resolve();
			});
		}

		this.menuOpen = false;

		scrollLock.enablePageScroll();

		this.menu.classList.remove('is-active');
		this.header.classList.remove('has-open-menu');

		this.hamburger.classList.remove('is-active');
		this.hamburger.setAttribute('aria-expanded', false);
		this.hamburger.setAttribute('aria-label', 'Open het menu');
	}

	toggleSubmenu(toggle) {
		const submenuId = toggle.getAttribute('aria-controls');
		const submenu = document.getElementById(submenuId);

		const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

		if (isExpanded) {
			this.closeSubmenu(toggle, submenu);
		} else {
			this.openSubmenu(toggle, submenu);
		}
	}

	openSubmenu(toggle, submenu) {
		this.submenuToggles.forEach((otherToggle) => {
			if (otherToggle === toggle) {
				return;
			}

			const otherSubmenu = document.getElementById(otherToggle.getAttribute('aria-controls'));

			if (otherToggle.getAttribute('aria-expanded') === 'true') {
				this.closeSubmenu(otherToggle, otherSubmenu);
			}
		});

		submenu.classList.add('is-open');
		toggle.setAttribute('aria-expanded', true);

		if (window.innerWidth < 1200) {
			gsap.fromTo(
				submenu,
				{ height: 0, opacity: 0 },
				{ height: 'auto', opacity: 1, duration: 0.3, ease: 'power2.out' }
			);
		} else {
			gsap.set(submenu, { clearProps: 'all' });
		}
	}

	closeSubmenu(toggle, submenu) {
		toggle.setAttribute('aria-expanded', false);

		if (window.innerWidth < 1200) {
			gsap.to(submenu, {
				height: 0,
				opacity: 0,
				duration: 0.25,
				ease: 'power2.in',
				onComplete: () => {
					submenu.classList.remove('is-open');
					gsap.set(submenu, { clearProps: 'all' });
				},
			});
		} else {
			submenu.classList.remove('is-open');
		}
	}
}
